const timeRegExp = /(?:([0-2]\d):([0-5]\d)(?::([0-5]\d))?|(23):(59):(60))(?:\.\d+)?(?:Z|[+-]\d\d:\d\d)?$/;

export default timeRegExp;
